import TealiumEventBuilder from '../../analytics/tealium/builders/tealium-event-builder';

class FulfilmentSelectorDialogController {
    constructor(fulfilmentSelectorService, analyticsService) {
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.analyticsService = analyticsService;
    }

    goToConfirmStep() {
        const event = new TealiumEventBuilder()
            .withScreenName('Manual Address entry')
            .withLabel('Button/link click')
            .withValue('Back')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .build();

        this.analyticsService.push(event);
        this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.confirm;
    }
}

FulfilmentSelectorDialogController.$inject = ['FulfilmentSelectorService', 'AnalyticsService'];

const fulfilmentSelectorDialogComponentDefinition = {
    controller: FulfilmentSelectorDialogController,
    template: require('./fulfilment-selector-dialog.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorDialogController,
    fulfilmentSelectorDialogComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-dialog.component.js